import { Box } from '@chakra-ui/react'
import dynamic from 'next/dynamic'
import React from 'react'

import { FormContext, type FormInputType } from '../types'

const EditableMathField = dynamic(
  () => import('react-mathquill').then(mod => mod.EditableMathField),
  { ssr: false }
)

const FormInputEquation: React.FC<{
  input: FormInputType & { type: 'equation' }
}> = ({ input }) => {
  const { name: inputName, disabled = false } = input
  const { onChange } = React.useContext(FormContext)
  const [value, setValue] = React.useState(input.initialValue ?? '')

  const handleChange = React.useCallback(
    (newValue: string) => {
      onChange(inputName, newValue)
      setValue(newValue)
    },
    [inputName, onChange]
  )

  return (
    <Box
      borderRadius="4px"
      border="1px solid"
      borderColor="border"
      width="100%"
      bg={disabled ? 'bg.subtle' : 'bg'}
      position="relative"
      cursor={disabled ? 'not-allowed' : 'text'}
    >
      <EditableMathField
        config={{
          substituteTextarea: () => {
            const textarea = document.createElement('textarea')
            textarea.disabled = disabled
            return textarea
          },
        }}
        latex={value}
        onChange={equation => handleChange(equation.latex())}
        onClick={e => {
          if (disabled === true) {
            e.preventDefault()
            e.stopPropagation()
          }
        }}
        style={{
          border: 'none',
          width: '100%',
          padding: '6px',
          borderRadius: '4px',
        }}
      />
    </Box>
  )
}

export default FormInputEquation
